import React from 'react'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './appSlider.scss'
const AppSlider = ({ children, settings = {} }) => {
  const slider_settings = Object.assign(
    {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    },
    settings
  )

  return (
    <div className="f-slider ">
      <Slider {...slider_settings}>{children}</Slider>
    </div>
  )
}

export default AppSlider
